// extracted by mini-css-extract-plugin
export var divider = "_n1-0";
export var systemMessage = "_n1-1";
export var systemMessageWrapper = "_n1-2";